'use strict';

import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Switch from '@material-ui/core/Switch';
let app = window.app;
export default class CustomSwitch extends PureComponent {
  state = {
    id: String(++app.form_index)
  };
  componentDidMount() {
    const component = this,
      props = this.props;
    if (typeof props.value !== 'undefined') return;
    props.onChange({
      e: null,
      value: [true, 'true'].includes(props['default-value']),
      name: props.name,
      source: 'DidMount'
    });
  }
  handleChange = e => {
    const component = this,
      props = this.props;
    props.onChange({
      e: e,
      value: e.target.checked,
      name: props.name
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    let class_name = props.className;
    if (props['full-width']) {
      class_name += (class_name ? ' ' : '') + 'u-full-width';
    }
    class_name += ' mui-switch';
    const checked = [true, 'true'].includes(props.value);
    let output = /*#__PURE__*/React.createElement(Fragment, null, props['top-label'] ? /*#__PURE__*/React.createElement("label", {
      className: "switch-label top u-no-select",
      htmlFor: state.id
    }, props['top-label']) : undefined, /*#__PURE__*/React.createElement("div", {
      className: class_name
    }, props['left-label'] ? /*#__PURE__*/React.createElement("label", {
      className: "switch-label left u-no-select",
      htmlFor: checked ? state.id : undefined
    }, props['left-label']) : undefined, /*#__PURE__*/React.createElement(Switch, {
      checked: checked,
      onChange: component.handleChange,
      name: props.name,
      color: "primary",
      className: props['switch-class'],
      style: {
        height: 'auto'
      },
      id: state.id,
      disabled: props['read-only'] === true
    }), props.label ? /*#__PURE__*/React.createElement("label", {
      className: "switch-label right u-no-select",
      htmlFor: checked ? undefined : state.id
    }, props.label) : undefined));
    return output;
  }
}
CustomSwitch.propTypes = {
  'default-value': PropTypes.bool,
  'full-width': PropTypes.bool,
  name: PropTypes.string.isRequired,
  'switch-class': PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  status: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired
};
CustomSwitch.defaultProps = {
  'full-width': true,
  'default-value': false,
  className: ''
};
